import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Input, Button, Typography, Alert, Space, Select } from "antd";
import {
  req_list_aps_courseselected,
  req_add_aps_dialogue_log,
} from "../../api";
import { AI_API_GENERATE_URL } from "../../utils/contrains";

const { Title } = Typography;

class AiPromptStandard extends Component {
  state = {
    question: "",
    output: "",
    fullResponse: "",
    error: "",
    isGenerating: false,
    isOutputComplete: false,
    copyButtonColor: "#8C0044", // Initial color of the button
    courses: [],
    selectedCourse: "基礎程式設計",
    dialogueLog: {
      ServiceName: "課後助教",
      RequestTopic: "基礎程式設計",
      ReviewerId: "Test-Programming",
      RequestUserId: "",
      RequestUserName: "",
      RequestDescription: "",
      ResponseDescription: "",
    },
  };

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderText = this.renderText.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentWillMount() {
    this.api_rows_list();
  }

  /////////////////////
  api_rows_list = async () => {
    const { token, userCode } = this.props.user;
    const result = await req_list_aps_courseselected(userCode, token);
    if (result.total > 0) {
      const items = result.data;
      const courses = items.map((item) => ({
        value: item.CourseOpenKey,
        label: item.CourseTwName,
      }));
      this.setState({ courses, selectedCourse: items[0].CourseTwName });
    } else {
      this.setState({
        courses: [
          {
            value: "Test-Programming",
            label: "基礎程式設計",
          },
          {
            value: "Test-English",
            label: "旅遊英語",
          },
          {
            value: "Test-Japanese",
            label: "旅遊日語",
          },
          {
            value: "Test-Korean",
            label: "旅遊韓語",
          },
        ],
        selectedCourse: "基礎程式設計",
      });
    }
  };

  api_add_item = async (item) => {
    const { token, userCode, userName } = this.props.user;
    item.RequestUserId = userCode;
    item.RequestUserName = userName;
    //console.log(item);
    await req_add_aps_dialogue_log(item, token);
  };

  handleInputChange(event) {
    this.setState({ question: event.target.value });
  }

  parseResponseData = (data) => {
    try {
      const lines = data.split("\n");
      const jsonArray = lines
        .filter((line) => line.trim() !== "")
        .map((line) => JSON.parse(line));
      return jsonArray;
    } catch (error) {
      console.error("解析 response.data 時發生錯誤：", error);
      return [];
    }
  };

  handleSubmit(event) {
    event.preventDefault();
    const { selectedCourse, dialogueLog } = this.state;
    const api_url = AI_API_GENERATE_URL;
    // console.log(selectedCourse);
    const payload = {
      model: "gemma2",
      prompt:
        `你扮演一位${selectedCourse}課程的專業老師，而我是學生，如果我問與${selectedCourse}課程無相關的問題，請你直接回答「非本專業的問題」，以下為我所提出的問題，請以繁體中文回答。假如${selectedCourse}課程為語言學習的課程，則以語言翻譯的方式回答:\n` +
        this.state.question,
    };

    dialogueLog.RequestDescription = this.state.question;
    this.setState({
      isGenerating: true,
      output: "",
      error: "",
      isOutputComplete: false,
      dialogueLog,
    });

    axios
      .post(api_url, payload)
      .then((response) => {
        if (response.status === 200) {
          const fullResponse = response.data;
          this.setState({ fullResponse }, () => {
            this.renderText(fullResponse);
          });
        } else {
          this.setState({
            error: `API 回應碼: ${response.status}`,
            isGenerating: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          error: `API 請求失敗：${error.message}`,
          isGenerating: false,
        });
      })
      .finally(() => {
        // Clear input field after submission
      });
  }

  handleChange = (value, option) => {
    let { dialogueLog } = this.state;
    dialogueLog.RequestTopic = option.label;
    dialogueLog.ReviewerId = value;
    this.setState({ selectedCourse: option.label, dialogueLog });
  };

  renderText(data) {
    const jsonArray = this.parseResponseData(data);

    if (jsonArray.length > 0) {
      const responses = jsonArray.map((item) => item.response).join("");

      let index = 0;
      this.setState({
        output: "",
        isGenerating: true,
        isOutputComplete: false,
      });

      this.interval = setInterval(() => {
        if (index < responses.length) {
          this.setState((prevState) => ({
            output: prevState.output + responses[index],
          }));
          index += 1;
        } else {
          clearInterval(this.interval);
          this.interval = null;
          this.setState({ isGenerating: false, isOutputComplete: true });
          // Add to database
          let { dialogueLog } = this.state;
          dialogueLog.ResponseDescription = this.state.output;
          this.api_add_item(dialogueLog);
        }
      }, 100);
    } else {
      this.setState({ output: "沒有有效的回應", isGenerating: false });
    }
  }

  stopRendering() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.setState({ isGenerating: false });
  }

  clearContent() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.setState({
      output: "",
      isGenerating: false,
      isOutputComplete: false,
      copyButtonColor: "#8C0044", // Reset button color
    });
  }

  formatOutputText(text) {
    // Replace double asterisks with <strong> tags
    text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
    // Replace triple backticks with <code> tags
    // text = text.replace(/```(.*?)```/g, "<code>$1</code>");
    return text;
  }

  copyToClipboard() {
    const { output, question } = this.state;
    const textToCopy = `提問：${question}\n回答：${output}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        // Change button color on successful copy
        this.setState({ copyButtonColor: "#4CAF50" }); // Change to green or any desired color
        setTimeout(() => {
          // Reset color after a delay
          this.setState({ copyButtonColor: "#8C0044" });
        }, 2000); // Reset after 2 seconds
      })
      .catch((err) => {
        console.error("複製失敗：", err);
      });
  }

  render() {
    const { selectedCourse, courses } = this.state;
    return (
      <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <Title level={1}>{selectedCourse}課後助教</Title>

        {/* Sticky Question Input Area */}
        <div
          style={{
            position: "sticky",
            top: "0",
            backgroundColor: "#fff",
            zIndex: "1000",
            paddingBottom: "10px",
          }}
        >
          <form onSubmit={this.handleSubmit}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "#E6E6FA",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              <Space
                direction="vertical"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Select
                  defaultValue={selectedCourse}
                  onChange={this.handleChange}
                  style={{
                    width: 200,
                  }}
                  options={courses}
                />
                <Input
                  id="questionInput"
                  type="text"
                  value={this.state.question}
                  style={{ height: "50px", width: "100%" }}
                  onChange={this.handleInputChange}
                  placeholder="輸入提問內容"
                  disabled={this.state.isGenerating}
                />
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={this.state.isGenerating}
                  >
                    {this.state.isGenerating ? "回應中" : "送出提問"}
                  </Button>
                  <Button
                    onClick={() => this.stopRendering()}
                    disabled={!this.state.isGenerating}
                  >
                    停止輸出
                  </Button>
                  <Button onClick={() => this.clearContent()}>清除內容</Button>
                </Space>
              </Space>
            </div>
          </form>
        </div>

        {this.state.error && (
          <Alert
            message="錯誤"
            description={this.state.error}
            type="error"
            showIcon
            style={{ marginTop: "20px" }}
          />
        )}

        <div
          style={{
            marginTop: "20px",
            whiteSpace: "pre-line",
            fontSize: "18px",
            lineHeight: "1.5",
            backgroundColor: this.state.isGenerating ? "#f0f0f0" : "#ffffff",
            padding: "10px",
            borderRadius: "5px",
            position: "relative",
          }}
          dangerouslySetInnerHTML={{
            __html:
              this.state.output &&
              `<strong>提問：</strong> ${this.state.question}<br />
               <strong>回答：</strong> ${this.formatOutputText(
                 this.state.output
               )}`,
          }}
        />

        {/* Copy button appears only when output is complete */}
        {this.state.isOutputComplete && (
          <Button
            onClick={this.copyToClipboard}
            style={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: this.state.copyButtonColor,
              borderColor: "#D3D3D3",
              color: "#FFFFFF",
            }}
          >
            <i className="fas fa-copy" style={{ marginRight: "5px" }}></i>{" "}
            複製內容
          </Button>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AiPromptStandard);
